<a
  class="wrapper d-flex flex-row align-items-center p-3"
  [href]="'/artists/' + item.artistId"
  target="_blank"
  [ngClass]="{ clickable: item.artistId }"
>
<div class="profile d-flex flex-center mr-3" *ngIf="!hideImage">
  <img *ngIf="imageUrl; else placeholderImg" [src]="imageUrl" class="cover-img" alt="{{ item?.title }} - line up image"/>
  <ng-template #placeholderImg>
    <img src="assets/images/user-placeholder.png" class="cover-img" alt="{{ item?.title }} - placeholder image"/>
  </ng-template>
</div>
<div class="d-flex flex-column">
  <p class="font-weight-bold mb-0">{{ item?.title }}</p>
  <p class="my-1" *ngIf="item?.startDate">
      {{ item?.startDate | date: "shortTime" }}
    </p>
  </div>
</a>
